export const email = "walmarek1987@gmail.com";